module.exports = __webpack_public_path__ + "img/fa-solid.6ec9b0a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/font-awesome/fa-solid.svg
// module id = 909
// module chunks = 0